export interface IQuyTrinhThoiGian{
    IdQuyTrinh:number,
    Loai:number, 
    ThuBay:boolean,
    ChuNhat:boolean,
    NgayLe:string,
    TuGio:string,
    DenGio:string,
    Buoi:number
}
export class QuyTrinhThoiGian {
    IdQuyTrinh:number=0;
    Loai:number=null; 
    ThuBay:boolean=false;
    ChuNhat:boolean=false;
    NgayLe:string=null;
    TuGio:string='10:00';
    DenGio:string='11:00';
    Buoi:number=0;
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/quy-trinh-thoi-gian.ts